import React, { Component } from "react";
import { Table, Button, Col, Row } from "antd";
import axios from "axios";
import PrintModal from '../components/PrintModal';
import moment from "moment-timezone"; // VALIDAR DATAS
import numeral from "numeral";
import "./Relatorios.css";

const { Column } = Table;

class PedidosPrintModal extends Component {
    state = {
        listaRegistros: [],
        visualizar: false,
        carregando: false,
    }

    componentDidUpdate(propsAnte, stateAnte) {
        if (!stateAnte.visualizar && this.state.visualizar) {
            this.getListaRegistros();
        }
    }

    getListaRegistros = () => {
        this.setState({ carregando: true, listaRegistros: [] });

        const { buscaDataIni, buscaDataFim, buscaControle, buscaPessoa, buscaUsuario } = this.props.filtros;

        let dataIni = '';
        if ((buscaDataIni) && (buscaDataIni !== undefined)) {
            dataIni = moment(buscaDataIni, 'DD/MM/YYYY').format('YYYY-MM-DD');
        }
        let dataFim = '';
        if ((buscaDataFim) && (buscaDataFim !== undefined)) {
            dataFim = moment(buscaDataFim, 'DD/MM/YYYY').format('YYYY-MM-DD');
        }

        axios
            .get('/vendas', {
                params: {
                    print: true,
                    numero: buscaControle,
                    pessoa: buscaPessoa.key,
                    usuario: buscaUsuario.key,
                    dataIni,
                    dataFim,
                    tipoVenda: this.props.tipoVenda,
                }
            })
            .then(response => {
                const { data } = response;
                this.setState({
                    listaRegistros: data.dados,
                    carregando: false,
                });
            })
            .catch(erro => {
                console.warn(erro);
                this.setState({
                    carregando: false,
                });
            });
    };

    onCancelar = () => {
        this.setState({
            visualizar: false
        })
    }

    onVisualizar = () => {
        this.setState({
            visualizar: true
        })
    }

    renderValor = (vlr, registro) => {
        return (
            <span> {numeral(parseFloat(vlr)).format('0,000.00')} </span>
        );
    };

    renderData = (data) => {
        if (data) {
            const dataMoment = moment(data);
            return (
                <span>
                    {dataMoment.format('DD/MM/YYYY HH:mm')}
                </span>
            )
        } else {
            <span></span>
        }
    }

    render() {
        const { listaRegistros, carregando, visualizar } = this.state;
        return (
            <span>
                <Button onClick={this.onVisualizar}>
                    Impressão
                </Button>

                <PrintModal
                    visible={visualizar}
                    onCancel={this.onCancelar}
                >
                    <div >
                        <div className="titulo">
                           {this.props.tipoVenda === 'V' ? "Vendas" : "Vendas em Condicional"}
                        </div>

                        <Row>
                            <Col xs={22} style={{ marginTop: 10, marginLeft: 20, textAlign: "right" }} >
                                <span style={{ fontWeight: "bold" }}>Qtde Vendas: </span>
                                <span>{this.props.qtdeVendas}</span>

                                <span style={{ fontWeight: "bold", marginLeft: 50 }}>Total Vendas: </span>
                                <span>R$ {this.renderValor(this.props.totalVendas)}</span>
                            </Col>
                        </Row>

                        <Table
                            pagination={false}
                            dataSource={listaRegistros}
                            className="tabela"
                            rowKey={(listaRegistros => listaRegistros.ven_idf)}
                            loading={{
                                spinning: carregando,
                                tip: 'Carregando. Aguarde...',
                                size: "large"
                            }}
                        >
                            <Column
                                key="ven_numero"
                                dataIndex="ven_numero"
                                title="Número"
                                width={80}
                                align="center"
                                className="listaCadastro"
                            />
                            <Column
                                key="ven_dt_venda"
                                dataIndex="ven_dt_venda"
                                title="Emissão"
                                render={this.renderData}
                                width={100}
                                align="center"
                                className="listaCadastro"
                            />
                            <Column
                                key="pes_nome"
                                dataIndex="pes_nome"
                                title="Cliente"
                                width={200}
                                align="left"
                                className="listaCadastro"
                            />
                            <Column
                                key="ven_vlr_total"
                                dataIndex="ven_vlr_total"
                                title="Valor Total"
                                render={this.renderValor}
                                width={90}
                                align="right"
                                className="listaCadastro"
                            />
                            <Column
                                key="usu_nome"
                                dataIndex="usu_nome"
                                title="Usuário"
                                width={90}
                                align="center"
                                className="listaCadastro"
                            />
                            {/* <Column
                                key="ven_dt_enviado"
                                dataIndex="ven_dt_enviado"
                                title="Sincronizado"
                                render={this.renderData}
                                width={160}
                                align="center"
                                className="listaCadastro"
                            /> */}

                        </Table>
                    </div>

                </PrintModal>
            </span>
        );
    }
}

export default PedidosPrintModal;



// WEBPACK FOOTER //
// ./src/relatorios/PedidosPrintModal.js